import { cn } from '@/lib/utils'
import { Spinner } from './spinner'

export interface LoadingStateProps {
	title?: string
	description?: string
	/** Styles the inner (text) block */
	className?: string
	/** Styles the outer container (should usually be `size-full`) */
	containerClassName?: string
	/** Styles the spinner icon */
	spinnerClassName?: string
}

export function LoadingState({
	title = 'Loading',
	description,
	className,
	containerClassName,
	spinnerClassName,
}: LoadingStateProps) {
	return (
		<div className={cn('flex items-center justify-center w-full h-full', containerClassName)}>
			<div className={cn('text-center space-y-2', className)}>
				<Spinner className={cn('mx-auto size-6 text-primary', spinnerClassName)} />
				<div className='space-y-1'>
					{title ? <p className='text-body font-medium text-foreground'>{title}</p> : null}
					{description ? <p className='text-body text-muted-foreground'>{description}</p> : null}
				</div>
			</div>
		</div>
	)
}
